import { render, staticRenderFns } from "./zhiboclassxqPartner.vue?vue&type=template&id=42994efa&scoped=true"
import script from "./zhiboclassxqPartner.vue?vue&type=script&lang=js"
export * from "./zhiboclassxqPartner.vue?vue&type=script&lang=js"
import style0 from "./zhiboclassxqPartner.vue?vue&type=style&index=0&id=42994efa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42994efa",
  null
  
)

export default component.exports